export const EXPENSE_TYPES = {
  ELECTRICITY: 'Electricity Bill',
  GAS: 'Gas Bill',
  INTERNET: 'Internet',
  MAINTENANCE: 'Maintenance',
  PARKING: 'Parking',
  PROPERTY_TAX: 'Property Tax',
  SALARY: 'Salary',
  SECURITY: 'Security',
  TRASH: 'Trash Bill',
  WATER: 'Water Bill',
  INSURANCE: 'Insurance',
  CLEANING: 'Cleaning',
  OTHER: 'Other'
};

export const EXPENSE_FREQUENCIES = {
  ONE_TIME: 'One Time',
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  YEARLY: 'Yearly'
};
